module.exports = __webpack_public_path__ + "img/ev_charger_power_on.8d7a4637.png";